













































import { Component, PropSync, Vue } from 'vue-property-decorator';
import UpdateBankAccountWealthSuccessViewModel
  from '@/vue-app/view-models/components/user-profile/user-profile-tabs/user-profile-my-documents-tab/update-bank-account/update-bank-account-wealth-success-view-model';

@Component({ name: 'UpdateBankAccountWealthSuccess' })
export default class UpdateBankAccountWealthSuccess extends Vue {
  @PropSync('isOpen', { type: Boolean, required: true })
  synced_is_open!: boolean;

  update_bank_wealth_success_view_model = Vue.observable(
    new UpdateBankAccountWealthSuccessViewModel(),
  );

  closeModal() {
    this.synced_is_open = false;
  }
}
